export default __webpack_public_path__ + "fonts/MarrSansCondensed-Bold-Web.woff";